import React from "react"
import {
  Bar,
  Line,
  Pie,
  Doughnut,
  PolarArea,
  Radar,
  Bubble,
  Scatter,
} from "react-chartjs-2"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
} from "chart.js"

// Register all necessary ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale
)

const chartComponents = {
  bar: Bar,
  line: Line,
  pie: Pie,
  doughnut: Doughnut,
  polarArea: PolarArea,
  radar: Radar,
  bubble: Bubble,
  scatter: Scatter,
}

const Chart = ({
  type = "bar",
  data,
  labels,
  datasets,
  title,
  backgroundColor = [
    "rgba(255, 99, 132, 0.6)",
    "rgba(54, 162, 235, 0.6)",
    "rgba(255, 206, 86, 0.6)",
    "rgba(75, 192, 192, 0.6)",
    "rgba(153, 102, 255, 0.6)",
    "rgba(255, 159, 64, 0.6)",
  ],
  borderColor = [
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
    "rgba(75, 192, 192, 1)",
    "rgba(153, 102, 255, 1)",
    "rgba(255, 159, 64, 1)",
  ],
  borderWidth = 1,
  options = {},
  width = "100%",
  height = "100%",
  className = "",
  horizontal = false, // New prop to control chart orientation
}) => {
  // Validate chart type
  const chartType = chartComponents[type.toLowerCase()]
    ? type.toLowerCase()
    : "bar"
  const ChartComponent = chartComponents[chartType]

  // Prepare chart data
  const chartData = {
    labels: labels || [],
    datasets: datasets || [
      {
        label: title || "Sales Data",
        data: data || [],
        backgroundColor,
        borderColor,
        borderWidth,
      },
    ],
  }

  // Default options with title if provided
  const defaultOptions = {
    responsive: true,
    // Add indexAxis for horizontal bars when horizontal prop is true and chart type is bar
    ...(horizontal && type === "bar" && { indexAxis: "y" }),
    plugins: {
      legend: {
        position: "top",
      },
      ...(title && {
        title: {
          display: true,
          text: title,
          font: {
            size: 16,
          },
        },
      }),
      ...options?.plugins,
    },
    ...options,
  }

  return (
    <div className={className} style={{ width, height }}>
      <ChartComponent data={chartData} options={defaultOptions} />
    </div>
  )
}

export default Chart
